import { useCurrentCast } from '@/modules/casts/compositions'
import { Ref, computed } from '@vue/composition-api'
import { SceneSourceType } from '../types'

const useSceneSourceType = (sceneId: Ref<string|null>) => {

  const { currentCast } = useCurrentCast()

  const sourceType = computed(() => {
    if (!sceneId.value || !currentCast.value) return SceneSourceType.Generic
    return currentCast.value.getSceneSourceType(sceneId.value)
  })

  const canAddSourceContents = computed(() => {
    return !([SceneSourceType.Broadcast, SceneSourceType.Websource, SceneSourceType.Generic].includes(sourceType.value))
  })
  const isSourceLayout = computed(() => sourceType.value === SceneSourceType.Layout)
  const isSourcePlaylist = computed(() => sourceType.value === SceneSourceType.Playlist)
  const isSourceReplay = computed(() => sourceType.value === SceneSourceType.Replay)
  const isSourceTalent = computed(() => sourceType.value === SceneSourceType.Talent)
  const isSourceTalentAnonymous = computed(() => sourceType.value === SceneSourceType.TalentAnonymous)
  const isSourceWebsource = computed(() => sourceType.value === SceneSourceType.Websource)
  const isSourceStation = computed(() => sourceType.value === SceneSourceType.Station)
  const isSourceAnyClips = computed(() => isSourcePlaylist.value || isSourceReplay.value)
  const isSourceAnyTalent = computed(() =>
    isSourceTalent.value || isSourceTalentAnonymous.value || isSourceStation.value)
  const isSourceCast = computed(() => sourceType.value === SceneSourceType.Cast)

  return {
    canAddSourceContents,
    isSourceAnyClips,
    isSourceAnyTalent,
    isSourceCast,
    isSourceLayout,
    isSourcePlaylist,
    isSourceReplay,
    isSourceStation,
    isSourceTalent,
    isSourceWebsource,
    sourceType
  }
}

export default useSceneSourceType
